import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { LinkModal } from '../../../../components/ATS/LinkModal/LinkModal';
import { ScriptService } from '../../../../controllers/ScriptService';
import { SvgCart } from '../../../../icons';
import { ProgramSource } from '../../../../queries/ats/titles/types/sources';
import { routes } from '../../../../routes/route-utils';
import { useAuth } from '../../../../utils/auth-utils';
import { getAltiboxServiceUrl } from '../../../../utils/svodUtil';
import { CallToAction } from '../call-to-action-button';

export function ProgramGetAccessCallToAction({ source }: { source: ProgramSource }) {
  const { t } = useTranslation();
  const location = useLocation();
  const auth = useAuth();
  const serviceLink = getAltiboxServiceUrl(source.providerIdentifier);
  const isDKUser = ScriptService.isDKUser();

  if (auth.isGuest) {
    return (
      <CallToAction
        text={{
          primary: t('details:get-access'),
        }}
        image={{
          src: source.image,
          alt: source.name,
        }}
        icon={<SvgCart />}
        to={routes.login(location)}
      />
    );
  }

  // Special case for paid-channels & Norwegian customers ONLY
  if (source.permissions.canOnlyBeBoughtWithMoney && !isDKUser) {
    return (
      <LinkModal
        id={source.id}
        title={t('channel:popup_title')}
        description={t('channel:popup_description_money')}
        primaryButton={{
          title: isDKUser ? t('channel:popup_continue_da') : t('channel:popup_continue_no'),
          url: serviceLink,
        }}
      >
        <CallToAction
          text={{
            primary: t('details:get-access'),
          }}
          image={{
            src: source.image,
            alt: source.name,
          }}
          icon={<SvgCart />}
        />
      </LinkModal>
    );
  }

  return (
    <LinkModal
      id={source.id}
      title={t('channel:popup_title')}
      description={isDKUser ? t('channel:popup_description_danish') : t('channel:popup_description_points')}
      primaryButton={{
        title: isDKUser ? t('channel:popup_continue_da') : t('channel:popup_continue_no'),
        url: serviceLink,
      }}
    >
      <CallToAction
        text={{
          primary: t('details:get-access'),
        }}
        image={{
          src: source.image,
          alt: source.name,
        }}
        icon={<SvgCart />}
      />
    </LinkModal>
  );
}
